import { t } from "i18next"

export const buyerCategoriesBayut = () => [
  { label: t("Saudi"), value: "saudi" },
  { label: t("Foreigner"), value: "foreigner" },
]

export const buyerCategoriesZameen = () => [
  { label: t("Pakistani"), value: "pakistani" },
  { label: t("Overseas Pakistani"), value: "overseas_pakistani" },
]
